import React, { Fragment, useCallback, useEffect } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import AuthLayout from "../Layout/AuthLayout";
import {
  useGetBookmarkEventMutation,
  useGetBookmarkMutation,
} from "../Store/api/DataApi";
import { useNavigate } from "react-router-dom";
import EventItemComponent from "../Components/AppliedEvents/EventItemComponent";
//import { logout } from "../Services/AuthService";

export default function BookmarkedEvent() {
  //const [currentPage, setCurrentPage] = useState(1);
  const [getBookmarkEvents, { data }] = useGetBookmarkEventMutation();
  const navigate = useNavigate();

  const bookmarkList = useCallback(() => {
    getBookmarkEvents();
  }, [getBookmarkEvents]);

  console.log(data);

  useEffect(() => {
    if (data?.error !== undefined && data?.error === "Invalid token!") {
      navigate("/logout");
    }
  }, [data, navigate]);

  useEffect(() => {
    bookmarkList();
  }, [bookmarkList]);

  return (
    <Fragment>
      <PageBannerComponent title="My Bookmarked Event" />
      <AuthLayout>
        {data?.length > 0 ? (
          data.map((job, i) => <EventItemComponent item={job} key={i} />)
        ) : (
          <div className="inner-box my-resume">
            <div className="text-center h4">You have no bookmark event.</div>
          </div>
        )}
      </AuthLayout>
    </Fragment>
  );
}
